var map = {
	"./dsp/Commodity": 776,
	"./dsp/Commodity.jsx": 776,
	"./dsp/LocationSuggestions": 777,
	"./dsp/LocationSuggestions.jsx": 777,
	"./imaging/TableImagingList": 510,
	"./imaging/TableImagingList.jsx": 510
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1209;